import { render, staticRenderFns } from "./AiAnonymization.vue?vue&type=template&id=1749397a&"
import script from "./AiAnonymization.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiAnonymization.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports